// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"modal_wrapper__iU47g","modal":"modal_modal__wgjkP","close":"modal_close__Cklrf"};